import React from "react";
import "../Css/Footer.css";

export default function Footer() {
  return (
    <div className="main-footer">

      <div className="footer-content">
        <div className="left-footer">
          <h2>Ouick & Useful Links</h2>
          <div className="rows">
            <div className="row-items">
              <ul>
                <li><a href="https://www.iitrpr.ac.in/head-departments">Heads of Departments</a></li>
                <li><a href="https://www.iitrpr.ac.in/iitropar-administration">Deans</a></li>
                <li><a href="https://www.iitrpr.ac.in/iitropar-administration">Associate Deans</a></li>
                <li><a href="https://www.iitrpr.ac.in/administrative-officers">Administrative Officials</a></li>
              </ul>
            </div>
            <div className="row-items">
              <ul>
                <li><a href="https://alumniconnect.iitrpr.ac.in/">Alumni IIT Ropar</a></li>
                <li><a href="https://www.iitrpr.ac.in/time-table">Current Timetable</a></li>
                <li><a href="https://www.iitrpr.ac.in/academic-calendar">Academic Calendar</a></li>
                <li><a href="https://www.iitrpr.ac.in/downloads/index.html">Downloads Forms</a></li>
              </ul>
            </div>
            <div className="row-items">
              <ul>
                <li><a href="https://www.iitrpr.ac.in/downloads/forms-hindi.html">Download Forms in Hindi</a></li>
                <li><a href="">Shuttle Bus</a></li>
                <li><a href="">Room Booking</a></li>
                <li><a href="https://www.google.com/maps/dir/Rupnagar+Old+Bus+Stand,+Chhota+Khera,+Basant+Nagar,+Rupnagar,+Punjab/iiT+Ropar+S+Ramanujan+block/@30.9620871,76.4694277,13z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x3905543310e70e63:0x63397d7938035537!2m2!1d76.5338308!2d30.9669692!1m5!1m1!1s0x39055541f9d03931:0xd82463b14ef85ff0!2m2!1d76.4757144!2d30.9690514!3e0?shorturl=1">How to Reach IIT Ropar</a></li>
              </ul>
            </div>
            <div className="row-items">
              <ul>
                <li><a href="https://www.iitrpr.ac.in/moodle/">Moodle</a></li>
                <li><a href="https://www.iitrpr.ac.in/helpdesk/">IT-Help Desk</a></li>
                <li><a href="https://www.iitrpr.ac.in/civil/?page_id=91">Contact Us</a></li>
                <li><a href="https://www.iitrpr.ac.in/aims/">AIMS Portal</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="right-footer">
            <h2>Contact Us</h2>
            <ul>
                <li>Department of Civil Engineering - IIT Ropar</li>
                <li>Rupnagar, Punjab, India, Pin-140001</li>
                <li>Tel : (+91) 01881-242248</li>
                <li>Email Us</li>
            </ul>
        </div>
      </div>

      <div className="lower-footer">
        <div className="low-cont">
            <p>©2022 Department of Civil Engineering - IIT Ropar. All Right Reserved.</p>
        </div>
        <div className="low-cont">
            <p>Site is maintained by the Department of Civil Engineering IIT Ropar</p>
        </div>
      </div>
    </div>
  );
}
